<template>
  <div
    :class="[
      $style.base,
      {
        [$style.zebra]: zebra,
        [$style.hasFooter]: hasFooter
      }
    ]"
  >
    <div
      v-if="hasHeader"
      :class="$style.action"
    />
    <div
      v-for="(row, index) in rows"
      :key="`action-${index}`"
      :class="[
        $style.action,
        {
          [$style.isEmpty]: !row.actions || !row.actions.length,
          [$style.hasEditableFields]: row.cells?.some((cell) => cell && cell.editable)
        }
      ]"
    >
      <BaseMore
        v-if="row.actions && row.actions.length"
        :options="row.actions"
        :size="row.actions.length === 1 ? 's' : 'm'"
        @select="$emit('action', { id: row.id, option: $event })"
        v-test="'_base-table-more'"
      />
    </div>
    <div
      v-if="hasFooter"
      :class="$style.action"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    rows: {
      type: Array,
      required: true,
    },
    zebra: {
      type: Boolean,
      default: false,
    },
    hasHeader: {
      type: Boolean,
      default: false,
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['action'],
});
</script>

<style
  lang="scss"
  module
>
$cellHeight: 55px;

// The fade before the sticky column starts from transparent rather than
// transparent white, so it doesn't lighten the edge in dark mode
@mixin white {
  background-color: var(--surface-primary);

  &:before {
    background: linear-gradient(to right, transparent, var(--surface-primary));
  }
}

@mixin gray {
  background-color: var(--surface-secondary);

  &:before {
    background: linear-gradient(to right, transparent, var(--surface-secondary));
  }
}
.action {
  position: relative;
  height: $cellHeight;
  display: flex;
  align-items: center;

  &.hasEditableFields {
    height: $input-height + ($spacing * 2) + 1px;
  }

  .base.zebra & {
    &:nth-child(odd) {
      @include white;
    }

    &:nth-child(even) {
      @include gray;
    }
  }

  .base.hasFooter & {
    &:last-child {
      @include gray;
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--border);
  }

  &:before {
    content: '';
    position: absolute;
    right: 100%;
    top: 0;
    height: 100%;
    width: $spacing;
  }
}
</style>
